import { render, staticRenderFns } from "./sincerelyBuy.vue?vue&type=template&id=968cd222&scoped=true"
import script from "./sincerelyBuy.vue?vue&type=script&lang=js"
export * from "./sincerelyBuy.vue?vue&type=script&lang=js"
import style0 from "./sincerelyBuy.vue?vue&type=style&index=0&id=968cd222&prod&lang=less&scoped=true"
import style1 from "./sincerelyBuy.vue?vue&type=style&index=1&id=968cd222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968cd222",
  null
  
)

export default component.exports